import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'replaceTokens',
  standalone: false,
})
export class ReplaceTokensPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string, tokens: { [key: string]: string }): SafeHtml {
    let result = value;

    Object.keys(tokens).forEach(token => {
      const regex = new RegExp(`\\[${token}\\]`, 'g');
      result = result.replaceAll(regex, tokens[token]);
    });

    return this.sanitizer.bypassSecurityTrustHtml(result);
  }
}
